<div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
</div>
  
  <div id="scanner-container">
  </div>
  
 
